import { render, staticRenderFns } from "./CustomerCredits.vue?vue&type=template&id=26977a11&scoped=true"
import script from "./CustomerCredits.vue?vue&type=script&lang=js"
export * from "./CustomerCredits.vue?vue&type=script&lang=js"
import style0 from "./CustomerCredits.vue?vue&type=style&index=0&id=26977a11&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26977a11",
  null
  
)

export default component.exports